<div
  *ngIf="!isServer"
  class="joymo__video_state p-x-16 p-y-20 flex flex-column flex-align-center gap-20"
>
  <ng-container [ngSwitch]="video.streamState">
    <ng-container *ngSwitchCase="'LIVE'">
      <ng-container *ngTemplateOutlet="progressBar"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'FINISHED'">
      <ng-container *ngTemplateOutlet="duration"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="null">
      <ng-container *ngTemplateOutlet="duration"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container
        *ngIf="getWithin24Hours(); then timeCountdown; else dateTimeCard"
      ></ng-container>
    </ng-container>
  </ng-container>
  <yo-button
    *ngIf="!hasAccess && !isAccessInactive"
    (click)="getAccessClicked.emit()"
    class="w-100"
    role="primary"
    [loading]="loading"
    [fullWidth]="true"
    size="xlarge"
    id="video_btn_access"
  >
    <ng-container *ngIf="!cheapestAccess" i18n="@@videoGetAccessButtonLabel"
      >Get Access</ng-container
    >
    <ng-container *ngIf="cheapestAccess && cheapestAccessLabel">
      <div class="flex flex-column flex-align-center p-12">
        <span class="text-lg text-semibold" i18n="@@videoGetAccessButtonLabel"
          >Get Access</span
        >
        <span class="text-sm text-regular">{{ cheapestAccessLabel }}</span>
      </div>
    </ng-container>
  </yo-button>
  <ng-container *ngIf="isAccessInactive">
    <span
      i18n="@@activeSubscriptionRequiredMessage"
      class="text-center text-lg md:text-md text-semibold"
      >An active subscription is required<br />to watch this video</span
    >
    <yo-button
      role="flat-square"
      [routerLink]="[homepageUrl, 'profile', 'subscriptions']"
    >
      <span class="text-semibold" i18n="@@goToMySubscriptionsButton"
        >Go to my subscriptions</span
      >
    </yo-button>
  </ng-container>
  <joymo-social-share
    [shareTitle]="video.name"
    [shareDescription]="video.description"
    [useLargeIcons]="true"
    [showSupportMessage]="true"
  ></joymo-social-share>
</div>

<ng-template #timeCountdown>
  <div
    class="joymo__video_state--countdown flex flex-align-center flex-column flex-justify-center"
  >
    <ng-container *ngIf="!startingSoon; else startingSoonTpl">
      <p class="text-md"><strong>Streaming starts in</strong></p>
      <div class="joymo__video_state--countdown-container p-12 flex flex-row">
        <ng-container
          *ngFor="
            let time of scheduledTimer$ | async;
            index as key;
            first as first;
            last as last
          "
        >
          <div
            class="time p-x-16 p-y-6 flex flex-column flex-align-center"
            [ngClass]="{ first: first, last: last }"
          >
            <div class="joymo__video_state--countdown-value text-semibold">
              <strong>{{ time.value }}</strong>
            </div>
            <div class="text-capitalize">{{ time.unitLong }}</div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #startingSoonTpl>
      <p class="m-b-12 text-md text-semibold w-100 text-center">
        Streaming is about to start...
      </p>
    </ng-template>
    <div>
      <div class="flex flex-row flex-align-center">
        <yo-icon icon="clock"></yo-icon>
        <span class="text-capitalize text-xs m-l-4">{{
          getCountdownDate()
        }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #progressBar>
  <div
    class="joymo__video_state--progress w-100 flex flex-column flex-align-center gap-20"
  >
    <div
      class="joymo__video_state--progress-header flex flex-row flex-align-center flex-justify-center heading-sm"
    >
      Stream is live<yo-icon icon="live" class="m-l-4" size="xl"></yo-icon>
    </div>
    <div class="w-100 joymo__video_state--progress-container">
      <div class="w-100 progress"></div>
      <div #progress class="progress since"></div>
      <div class="flex flex-row flex-justify-between">
        <span class="from-start">{{
          timer$ ? (timer$ | async) : getTimeSinceStart()
        }}</span>
        <span class="to-end">{{ getTimeUntilEnd() }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #duration>
  <span class="duration text-md"
    ><strong
      ><span i18n="@@videoSateDurationLabel">Duration</span>:
      {{ getReadableDuration() }}</strong
    ></span
  >
</ng-template>

<ng-template #dateTimeCard>
  <yo-date-time-card
    *ngIf="video.startTime"
    class="block"
    [date]="video.startTime"
    [timeLabel]="getTimeLabel()"
  ></yo-date-time-card>
</ng-template>
